/**
 * Tasks → Board view.
 *
 * Kanban board, moved out of the `/tasks` index in PR #41 when Today
 * took over as the default landing. The component itself lives at
 * `components/tasks/TaskBoard.tsx`; this file is just the route wrapper.
 *
 * Reference: spec section 15.4.
 */

import { createFileRoute } from '@tanstack/react-router';

import { TaskBoard } from '@/components/tasks/TaskBoard';

export const Route = createFileRoute('/tasks/board')({
  component: TaskBoard,
});
